/* Gave ved køb for 599 kr., version 2 (Michael 20-21/9 2026).
   Tre dele i én fil:
     1. <cart-gave>: udvalget af strømpepakker i et vindue. Tilstande: mangler → vaelg → valgt.
     2. Vinduet: åbnes af alle links til "#gave" (baren under logoet, linjen på produktsiden).
     3. Baren under logoet: teksten følger kurven ("ligesom på bambuni").
   Grænsen regnes UDEN gaven selv. Prisen 0 kr. kommer fra rabatten i Shopify.
   Kurven selv røres ikke: version 1 lå inde i kurven og skubbede CHECK UD ud af skærmen.
   15/10 2026 (Michael: "grænsen i kundens valuta og tekster på svensk, tysk og engelsk"): rabatten i Shopify kræver
   599 DKK. På .se/.de/.com omregnes grænsen med Shopify.currency.rate (599 DKK = ca. 896 SEK), og teksterne følger sproget.
   Før viste den svenske kurv gaven som optjent ved 599 SEK, og kunden betalte for gaven (Fredrik, Gorgias 95691162). */
import Cart from "cart-store";

const GRAENSE_DKK = 59900;   // rabattens krav i butikkens valuta (DKK), eksklusiv gaven
const EGENSKAB = "_gave";
const VALUTA = (window.Shopify && Shopify.currency && Shopify.currency.active) || "DKK";
const KURS = Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
// Kundens valuta. Rundes OP, så vi aldrig lover gaven under det, rabatten kræver.
const GRAENSE = Math.ceil(GRAENSE_DKK * KURS);
const SPROG = ((window.Shopify && Shopify.locale) || document.documentElement.lang || "da").slice(0, 2);

const TEKST = {
  da: { mangler: x => `Køb for <b>${x}</b> mere, så kan du vælge dine gratis strømper.`,
        vaelg: "<b>Du har optjent en gratis strømpepakke.</b> Vælg den her.", valgt: "<b>Din gave ligger i kurven.</b>",
        stoerrelse: "Vælg størrelse", vaelgKnap: "Vælg", skift: "Skift", tilKurv: "Gå til kurven", luk: "Luk",
        barValgt: n => "Din gave er valgt: " + n, barSkift: "Skift gave", barOptjent: "Du har optjent en gratis strømpepakke",
        barVaelg: "Vælg din gave", barMangler: x => "Køb for " + x + " mere og få en gratis strømpepakke",
        barTom: x => "Køb for " + x + " og få en gratis strømpepakke", barSe: "Se pakkerne" },
  sv: { mangler: x => `Handla för <b>${x}</b> till, så kan du välja dina gratis strumpor.`,
        vaelg: "<b>Du har tjänat ett gratis strumppaket.</b> Välj det här.", valgt: "<b>Din gåva ligger i varukorgen.</b>",
        stoerrelse: "Välj storlek", vaelgKnap: "Välj", skift: "Byt", tilKurv: "Gå till varukorgen", luk: "Stäng",
        barValgt: n => "Din gåva är vald: " + n, barSkift: "Byt gåva", barOptjent: "Du har tjänat ett gratis strumppaket",
        barVaelg: "Välj din gåva", barMangler: x => "Handla för " + x + " till och få ett gratis strumppaket",
        barTom: x => "Handla för " + x + " och få ett gratis strumppaket", barSe: "Se paketen" },
  de: { mangler: x => `Kaufen Sie noch für <b>${x}</b> ein, dann können Sie Ihre Gratis-Socken wählen.`,
        vaelg: "<b>Sie haben ein Gratis-Sockenpaket verdient.</b> Wählen Sie es hier.", valgt: "<b>Ihr Geschenk liegt im Warenkorb.</b>",
        stoerrelse: "Größe wählen", vaelgKnap: "Wählen", skift: "Ändern", tilKurv: "Zum Warenkorb", luk: "Schließen",
        barValgt: n => "Ihr Geschenk ist gewählt: " + n, barSkift: "Geschenk ändern", barOptjent: "Sie haben ein Gratis-Sockenpaket verdient",
        barVaelg: "Geschenk wählen", barMangler: x => "Kaufen Sie noch für " + x + " ein und erhalten Sie ein gratis Sockenpaket",
        barTom: x => "Kaufen Sie für " + x + " ein und erhalten Sie ein gratis Sockenpaket", barSe: "Pakete ansehen" },
  en: { mangler: x => `Spend <b>${x}</b> more to choose your free socks.`,
        vaelg: "<b>You have earned a free sock pack.</b> Choose it here.", valgt: "<b>Your gift is in the cart.</b>",
        stoerrelse: "Choose size", vaelgKnap: "Choose", skift: "Change", tilKurv: "Go to cart", luk: "Close",
        barValgt: n => "Your gift is chosen: " + n, barSkift: "Change gift", barOptjent: "You have earned a free sock pack",
        barVaelg: "Choose your gift", barMangler: x => "Spend " + x + " more and get a free sock pack",
        barTom: x => "Spend " + x + " and get a free sock pack", barSe: "See the packs" },
};
const T = TEKST[SPROG] || TEKST.en;

// Beløb i kundens valuta: kroner uden decimaler ("897 kr"), euro med ("80,14 €")
function penge(øre) {
  if (VALUTA === "DKK") return new Intl.NumberFormat("da-DK", { maximumFractionDigits: 0 }).format(Math.ceil(øre / 100)) + " kr.";
  if (VALUTA === "SEK" || VALUTA === "NOK") return new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 0 }).format(Math.ceil(øre / 100)) + " kr";
  try { return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: VALUTA }).format(Math.ceil(øre) / 100); }
  catch (e) { return (Math.ceil(øre) / 100).toFixed(2) + " " + VALUTA; }
}

function del(kurv) {
  const linjer = (kurv && kurv.items) || [];
  const gave = linjer.find(l => l.properties && l.properties[EGENSKAB]);
  const basis = linjer.filter(l => l !== gave).reduce((sum, l) => sum + l.final_line_price, 0);
  return { gave, basis };
}

/* ---- 1. udvalget ---------------------------------------------------------------------- */
class CartGave extends HTMLElement {
  connectedCallback() {
    this.graense = GRAENSE;   // data-graense (59900) er DKK; omregnet ovenfor
    this.varer = JSON.parse(this.querySelector(".gave__data").textContent);
    this.overskrift = this.querySelector(".gave__overskrift");
    this.fyld = this.querySelector(".gave__fyld");
    this.indhold = this.querySelector(".gave__indhold");
    this.aaben = null;
    this.travl = false;
    this.tegn(Cart.getState().cart);
    this.unsubscribe = Cart.subscribe(state => this.tegn(state.cart));
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
  }

  tegn(kurv) {
    if (!kurv) return;
    const { gave, basis } = del(kurv);
    // Gaven må ikke blive liggende under grænsen — og aldrig i to stk.
    // Kun vinduets element (data-styrer) retter kurven; kurv-sidens kopi tegner bare.
    if (this.hasAttribute("data-styrer")) {
      if (gave && basis < this.graense) return this.#aendr(gave.key, 0);
      if (gave && gave.quantity > 1) return this.#aendr(gave.key, 1);
    } else if (gave && (basis < this.graense || gave.quantity > 1)) return;
    if (gave) return this.#tegnValgt(gave);
    if (basis >= this.graense) return this.#tegnValg();
    this.#tegnMangler(this.graense - basis, basis);
  }

  #tegnMangler(mangler, basis) {
    this.dataset.tilstand = "mangler";
    this.overskrift.innerHTML = T.mangler(penge(mangler));
    this.fyld.style.width = Math.min(100, (basis / this.graense) * 100) + "%";
    this.aaben = null;
    this.#liste(false);
  }

  #tegnValg() {
    this.dataset.tilstand = "vaelg";
    this.overskrift.innerHTML = T.vaelg;
    this.#liste(true);
  }

  /* kan_vaelge=false viser pakkerne uden knapper, så kunden kan se hvad der venter */
  #liste(kanVaelge) {
    this.indhold.textContent = "";
    const liste = document.createElement("div");
    liste.className = "gave__liste";
    this.varer.forEach((vare, nr) => liste.append(this.#kort(vare, nr, kanVaelge)));
    this.indhold.append(liste);
  }

  #kort(vare, nr, kanVaelge) {
    const boks = document.createElement("div");
    boks.className = "gave__vare";
    const billede = document.createElement("img");
    billede.src = vare.billede; billede.alt = vare.titel; billede.loading = "lazy";
    const navn = document.createElement("div");
    navn.className = "gave__navn"; navn.textContent = vare.titel;
    boks.append(billede, navn);
    if (!kanVaelge) return boks;

    if (this.aaben === nr) {
      const valg = document.createElement("div");
      valg.className = "gave__stoerrelser";
      vare.varianter.forEach(v => {
        const knap = document.createElement("button");
        knap.type = "button"; knap.className = "gave__stoerrelse"; knap.textContent = v.titel;
        knap.addEventListener("click", () => this.#vaelg(v.id));
        valg.append(knap);
      });
      boks.append(valg);
    } else {
      const knap = document.createElement("button");
      knap.type = "button"; knap.className = "gave__knap";
      knap.textContent = vare.varianter.length > 1 ? T.stoerrelse : T.vaelgKnap;
      knap.addEventListener("click", () => {
        if (vare.varianter.length === 1) return this.#vaelg(vare.varianter[0].id);
        this.aaben = nr;
        this.#tegnValg();
      });
      boks.append(knap);
    }
    return boks;
  }

  #tegnValgt(gave) {
    this.dataset.tilstand = "valgt";
    this.aaben = null;
    this.overskrift.innerHTML = T.valgt;
    this.indhold.textContent = "";
    const raekke = document.createElement("div");
    raekke.className = "gave__valgt";
    if (gave.image) {
      const billede = document.createElement("img");
      billede.src = gave.image; billede.alt = ""; raekke.append(billede);
    }
    const tekst = document.createElement("div");
    tekst.className = "gave__valgt-tekst";
    tekst.textContent = gave.product_title;
    const under = document.createElement("span");
    under.textContent = (gave.variant_title ? gave.variant_title + " · " : "") + penge(0);
    tekst.append(under);
    const skift = document.createElement("button");
    skift.type = "button"; skift.className = "gave__link"; skift.textContent = T.skift;
    skift.addEventListener("click", () => this.#tegnValg());
    const kurv = document.createElement("a");
    kurv.className = "gave__link"; kurv.href = "/cart"; kurv.textContent = T.tilKurv;
    if (/^\/cart\/?$/.test(location.pathname)) {  // står man allerede i kurven, gør linket intet synligt
      kurv.textContent = T.luk;
      kurv.addEventListener("click", e => { e.preventDefault(); const d = this.closest("dialog"); if (d) d.close(); });
    }
    raekke.append(tekst, skift, kurv);
    this.indhold.append(raekke);
  }

  async #vaelg(variantId) {
    if (this.travl) return;
    this.#travl(true);
    try {
      const { gave } = del(Cart.getState().cart);
      if (gave) await Cart.change({ id: gave.key, quantity: 0 });
      // cart-store forventer noeglen "properties[navn]"; et properties-objekt bliver pakket forkert ind
      await Cart.add({ id: variantId, quantity: 1, ["properties[" + EGENSKAB + "]"]: "ja" });
    } finally {
      this.#travl(false);
    }
  }

  async #aendr(key, antal) {
    if (this.travl) return;
    this.#travl(true);
    try { await Cart.change({ id: key, quantity: antal }); } finally { this.#travl(false); }
  }

  #travl(til) {
    this.travl = til;
    this.classList.toggle("gave__travl", til);
  }
}
if (!customElements.get("cart-gave")) customElements.define("cart-gave", CartGave);

/* ---- 2. vinduet --------------------------------------------------------------------------- */
const vindue = document.getElementById("gave-vindue");
if (vindue) {
  document.addEventListener("click", e => {
    const link = e.target.closest('a[href="#gave"], a[href$="/#gave"]');
    if (link) {
      e.preventDefault();
      const iKurven = document.querySelector("cart-gave.gave--kurv");
      if (iKurven && iKurven.offsetParent !== null) iKurven.scrollIntoView({ block: "center" });
      else vindue.showModal();
      return;
    }
    if (e.target.closest("[data-gave-luk]") || e.target === vindue) vindue.close();
  });
  if (location.hash === "#gave") vindue.showModal();

  // linjen i produktsidens tjekliste er ren tekst i temaet; gør den klikbar her
  document.querySelectorAll(".trust-messages__item").forEach(li => {
    if (!/strømpepakke|strumppaket|sockenpaket|sock pack/i.test(li.textContent)) return;
    li.style.cursor = "pointer";
    li.setAttribute("role", "button");
    li.setAttribute("tabindex", "0");
    li.addEventListener("click", () => vindue.showModal());
    li.addEventListener("keydown", e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); vindue.showModal(); } });
  });
}

/* ---- 3. baren under logoet ------------------------------------------------------------------ */
function barFelter() {
  return [...document.querySelectorAll(".announcement__text")]
    .filter(e => /strømpepakke|strumppaket|sockenpaket|sock pack|din gave|din gåva|ihr geschenk|your gift/i.test(e.textContent))
    .map(e => ({ tekst: e.querySelector("span"), link: e.querySelector("a") }))
    .filter(f => f.tekst);
}

function skrivBar(kurv) {
  const { gave, basis } = del(kurv);
  let tekst, link;
  if (gave) { tekst = T.barValgt(gave.product_title); link = T.barSkift; }
  else if (basis >= GRAENSE) { tekst = T.barOptjent; link = T.barVaelg; }
  else if (basis > 0) { tekst = T.barMangler(penge(GRAENSE - basis)); link = T.barSe; }
  else { tekst = T.barTom(penge(GRAENSE)); link = T.barSe; }
  barFelter().forEach(f => {
    f.tekst.textContent = tekst;
    if (f.link) { f.link.textContent = link; f.link.setAttribute("href", "#gave"); }
  });
}
skrivBar(Cart.getState().cart);
Cart.subscribe(state => skrivBar(state.cart));
